(function () {
  const style = document.createElement('style');
  style.textContent = `
    .wishlist-heart {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 22px;
      line-height: 1;
      color: rgba(0,0,0,0.25);
      padding: 5px;
      transition: color 0.2s, transform 0.15s;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .wishlist-heart:hover { transform: scale(1.25); color: #cc2233; }
    .wishlist-heart--active { color: #cc2233; }
    .wishlist-heart-wrapper {
      position: absolute;
      top: 6px;
      right: 6px;
      z-index: 2;
    }
  `;
  document.head.appendChild(style);

  const STORAGE_KEY = 'wl';

  class WishlistManager {
    constructor() {
      try {
        this.list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        if (!Array.isArray(this.list)) this.list = [];
      } catch (e) {
        this.list = [];
      }
      this._init();
    }

    _init() {
      document.addEventListener('click', (e) => {
        const heart = e.target.closest('[data-wishlist-heart]');
        if (heart) { e.preventDefault(); e.stopPropagation(); this._handleHeart(heart); return; }

        const removeBtn = e.target.closest('[data-wishlist-remove]');
        if (removeBtn) { e.preventDefault(); this._handleRemove(removeBtn); }
      }, true);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this._updateAllHearts());
      } else {
        this._updateAllHearts();
      }
    }

    _handleHeart(btn) {
      this.toggle(btn.dataset.handle);
    }

    _handleRemove(btn) {
      const handle = btn.dataset.handle;
      this.list = this.list.filter(h => h !== handle);
      this._save();
      this._updateAllHearts();
      const item = btn.closest('[data-wishlist-item]');
      if (item) item.remove();
    }

    toggle(handle) {
      if (this.isInList(handle)) {
        this.list = this.list.filter(h => h !== handle);
      } else {
        this.list.push(handle);
      }
      this._save();
      this._updateAllHearts();
    }

    isInList(handle) {
      return this.list.includes(handle);
    }

    _save() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.list));
    }

    _updateAllHearts() {
      const svgFilled = `<svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>`;
      const svgOutline = `<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="1.8" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
      document.querySelectorAll('[data-wishlist-heart]').forEach((btn) => {
        const active = this.isInList(btn.dataset.handle);
        btn.classList.toggle('wishlist-heart--active', active);
        btn.setAttribute('aria-label', active ? 'Verwijder van verlanglijst' : 'Voeg toe aan verlanglijst');
        btn.innerHTML = active ? svgFilled : svgOutline;
      });
    }
  }

  window.WishlistManager = new WishlistManager();
})();
